// extracted by mini-css-extract-plugin
export var button = "_c6-4";
export var hasDarkBackground = "_c6-7";
export var hasLightBackground = "_c6-6";
export var iconWrapper = "_c6-0";
export var large = "_c6-2";
export var medium = "_c6-1";
export var small = "_c6-5";
export var xsmall = "_c6-3";